(()=>{
 document.addEventListener('submit',async event=>{
  const form=event.target.closest('form[data-sf-buy]');if(!form)return;
  event.preventDefault();event.stopImmediatePropagation();
  if(form.dataset.busy)return;form.dataset.busy='true';
  const button=form.querySelector('button'),error=form.closest('.sf-actions').querySelector('.sf-error');
  const label=button.textContent;button.disabled=true;button.textContent='Opening checkout…';error.hidden=true;
  try{
   const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
   const data=await response.json();if(!response.ok)throw Error(data.description||'Please try again.');
   document.dispatchEvent(new CustomEvent('cart:add',{detail:{id:data.variant_id||data.id,qty:1,product:data}}));
   location.assign((window.Shopify?.routes?.root||'/')+'checkout');
  }catch(e){error.textContent=e.message;error.hidden=false;button.disabled=false;button.textContent=label;delete form.dataset.busy}
 },true);
})();
